export class ParticipantService {
  public static getApiPath = (requestType: string): string => {
    if (requestType !== 'bond') return `/participant/${requestType}/positions/list/`;
    return '/participant/bond/requests/list/';
  };
}

export default ParticipantService;
